module.exports = __webpack_public_path__ + "static/media/logo.2107e3a3.svg";